import { BasicsBaseApiV2 } from "../BasicsBaseApiV2";

export class ActReFlowTypeApi extends BasicsBaseApiV2 {

    public get ControllerName(): any {
        return 'actreflowType';
    }

    /**
     * 获取没有选择的流程类型	
     * @param projectId 
     * @returns 
     */
    public getNoSelectedFlowTypes(projectId: number) {
        return this.runAction("GetNoSelectedFlowTypes-E21-M31-S104", {
            projectId
        });
    }    

}